module.exports = __webpack_public_path__ + "assets/static/png/ico-master-min.7067f2966e34699637b3726a725eea7d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/ico-master-min.png
 ** module id = 536
 ** module chunks = 1
 **/